import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { MoneyMarketData } from '../MoneyMarketMonitorPage';

export function useMMFData(
  tfund: string | undefined,
  adate: string | undefined,
) {
  return useQuery({
    queryKey: ['mmf-data', tfund, adate],
    queryFn: () => getMMFData(tfund!, adate!),
    enabled: !!tfund && !!adate,
  });
}

export const getMMFData = async (
  tfund: string,
  adate: string,
): Promise<MoneyMarketData> => {
  return (await AxiosInstance.get(`get_mmf_data/${tfund}/${adate}`)).data;
};
